import { render, staticRenderFns } from "./EditOrderProduct.vue?vue&type=template&id=a31d10c4&scoped=true"
import script from "./EditOrderProduct.vue?vue&type=script&lang=js"
export * from "./EditOrderProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31d10c4",
  null
  
)

export default component.exports